<div class="header-container">
  <div class="logo-container">
    <a (click)="toggleSidebar()" href="#" class="sidebar-toggle">
      <nb-icon icon="menu-2-outline"></nb-icon>
    </a>
    <!-- <a class="logo" href="#" (click)="navigateHome()">

      <img src="assets/images/logo-reno.png" alt="Logo" class="logo-image">

    </a> -->
    
  </div>
  <!-- <nb-select [selected]="currentTheme" (selectedChange)="changeTheme($event)" status="primary">
    <nb-option *ngFor="let theme of themes" [value]="theme.value"> {{ theme.name }}</nb-option>
  </nb-select> -->
  <span class="titulo-sistma">Sistema Reno Inteligência</span>
</div>

<div class="header-container">
  <ngx-maintenance-banner></ngx-maintenance-banner>

  <!-- Session Expiration Warning Balloon -->
  <div *ngIf="mostrarAvisoExpiracao" class="session-warning-balloon">
    <div class="balloon-content" [class.expired]="sessaoExpirada">
      <div class="balloon-icon">
        <nb-icon [icon]="sessaoExpirada ? 'alert-circle-outline' : 'alert-triangle-outline'"></nb-icon>
      </div>
      <div class="balloon-message">
        <h4>{{ sessaoExpirada ? 'Sessão expirada' : 'Sessão expirando em breve' }}</h4>
        <p *ngIf="!sessaoExpirada">
          Sua sessão expirará em <strong>{{ tempoRestanteMinutos }} minuto{{ tempoRestanteMinutos !== 1 ? 's' : '' }}</strong>.
        </p>
        <p *ngIf="sessaoExpirada">
          Sua sessão expirou. Use o botão abaixo para renovar sem sair da tela.
        </p>
        <p *ngIf="!sessaoExpirada" class="secondary-text">
          Renove a sessão para evitar interrupção do trabalho.
        </p>
      </div>
      <div class="balloon-actions">
        <button class="btn-dismiss" (click)="dispensarAvisoExpiracao()" *ngIf="!sessaoExpirada">
          Dispensar
        </button>
        <button class="btn-login" (click)="onRenovarSessaoClick()">
          Renovar sessão
        </button>
      </div>
    </div>
  </div>

  <nb-actions size="tiny">
    <!-- Connectivity Status Icon -->
    <nb-action class="control-item connectivity-status"
               *ngIf="conectividadeRuim"
               nbTooltip="Conexão lenta detectada - Sua internet pode estar instável"
               nbTooltipPlacement="bottom">
      <div class="bad-connectivity-container">
        <nb-icon icon="wifi-off-outline" class="bad-connectivity-icon"></nb-icon>
        <span class="connectivity-label">Conexão Lenta</span>
      </div>
    </nb-action>

    <!-- Custom Theme Toggle -->
    <nb-action class="control-item theme-toggle">
      <div class="custom-toggle-container">
        <label class="custom-toggle">
          <input type="checkbox"
                 [checked]="tipoTema === 'Escuro'"
                 (change)="mudarTema()">
          <span class="toggle-slider">
            <span class="toggle-icon">{{ tipoTema === 'Escuro' ? '🌙' : '☀️' }}</span>
          </span>
        </label>
      </div>
    </nb-action>

    <!-- Indicador de fechamento (permissão unitária Termômetro) -->
    <nb-action *ngIf="temPermissaoTermometro" class="control-item fechamento-action">
      <ngx-termometro-data-fechamento
        [usuarioId]="usuarioId"
        [ehExecutivo]="ehExecutivo"
        (fechouDicaTermometro)="onFechouDicaTermometro()">
      </ngx-termometro-data-fechamento>
    </nb-action>

    <!-- Notificações -->
    <nb-action class="control-item notificacoes-action">
      <div class="header-notificacoes-wrap">
        <ngx-notificacoes [usarEndpointPendentes]="headerNotificacoesUsaApiPendentes"></ngx-notificacoes>
        <div *ngIf="mostrarTooltipNotificacao"
             class="header-edu-tooltip header-edu-tooltip--notificacao"
             (click)="$event.stopPropagation()">
          <div class="tooltip-arrow"></div>
          <div class="tooltip-content">
            <p><strong>Dica:</strong> O <strong>sino</strong> concentra avisos do sistema. O número vermelho mostra quantos avisos ainda <strong>não foram lidos</strong>. Clique no sino para abrir a lista, ler com calma e marcar como lidas quando quiser.</p>
            <div class="tooltip-footer">
              <label class="dont-show-checkbox">
                <input type="checkbox" #dontShowNotif>
                <span>Não mostrar novamente</span>
              </label>
              <button type="button" class="got-it-btn"
                      (click)="fecharTooltipNotificacao(dontShowNotif.checked)">
                Entendi
              </button>
            </div>
          </div>
        </div>
      </div>
    </nb-action>
    
    <!-- Beautiful Appointment Book Icon -->
    <nb-action class="control-item appointment-action" 
               *ngIf="temPermissaoAgenda"
               (click)="abrirAgendaCompromissos()"
               nbTooltip="Agenda de Compromissos"
               nbTooltipPlacement="bottom">
      <div class="appointment-icon-container">
        <nb-icon icon="clock-outline" class="appointment-icon"></nb-icon>
        <span class="appointment-label">Agenda</span>
        <div *ngIf="temCompromissosHoje" 
             class="appointment-star" 
             (click)="abrirProximoCompromisso(); $event.stopPropagation()"
             nbTooltip="Próximo compromisso hoje"
             nbTooltipPlacement="bottom">
          <span class="star-icon">★</span>
          
          <!-- Beautiful Star Tooltip -->
          <div *ngIf="mostrarTooltipEstrela" 
               class="star-tooltip"
               (click)="$event.stopPropagation()">
            <div class="tooltip-arrow"></div>
            <div class="tooltip-content">
              <p><strong>💡 Dica:</strong> Clique na estrela para abrir diretamente o próximo compromisso de hoje!</p>
              <div class="tooltip-footer">
                <label class="dont-show-checkbox">
                  <input type="checkbox" #dontShowCheckbox>
                  <span>Não mostrar novamente</span>
                </label>
                <button class="got-it-btn" 
                        (click)="fecharTooltipEstrela(dontShowCheckbox.checked)">
                  Entendi
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </nb-action>
    
    <!-- <nb-action class="control-item">
      <nb-search type="rotate-layout"></nb-search>
    </nb-action>
    <nb-action class="control-item" icon="email-outline"></nb-action>
    <nb-action class="control-item" icon="bell-outline"></nb-action> -->

    <!-- <nb-action>
      <h3></h3><span class="color-recebiveis">R$ 100,00</span>
    </nb-action> -->

    <!-- User Menu -->
    <nb-action class="user-action" *nbIsGranted="['view', 'user']" >
      <nb-user [nbContextMenu]="userMenu"
               [onlyPicture]="userPictureOnly"
               [name]="user.nome"
               [picture]="user.picture">
      </nb-user>
    </nb-action>
  </nb-actions>
</div>

<!-- Appointment Book Overlay -->
<div *ngIf="mostrarAgendaCompromissos" 
     class="appointment-overlay" 
     (click)="fecharAgendaCompromissos()">
  <div class="appointment-content" 
       (click)="$event.stopPropagation()">
    <ngx-agenda-compromissos #agendaComponent></ngx-agenda-compromissos>
    <button class="close-overlay-btn" 
            (click)="fecharAgendaCompromissos()"
            nbTooltip="Fechar"
            nbTooltipPlacement="left"
            aria-label="Fechar agenda de compromissos">
      <nb-icon icon="close-outline"></nb-icon>
    </button>
  </div>
</div>
